import { ISHOP_LINKS, MFE } from '@/utilities/constants';
import { PRE_LOGIN_INSTRUCTION_ROUTES } from '@/utilities/constants/instructions';
import { SystemIcon } from 'br2s-ui-componentlibrary_r2_02/dist/foundation/assets/system-icon';

export type Transaction = {
  id: string;
  label: string;
  href: string;
  icon?: SystemIcon;
  newTab?: boolean;
  deprioHref?: string;
  deprioFlag?: string;
  displayFlag?: string;
};

export const TRANSACTIONS: { [key: string]: Record<string, Transaction> } = {
  REGISTER: {
    registerNewEntity: {
      id: 'register-new-business-entity',
      label: 'Register new business entity',
      href: `/instruction/${PRE_LOGIN_INSTRUCTION_ROUTES.ENTITY_REGISTRATION}`,
      icon: SystemIcon.BusinessBusiness,
    },
    registerNewBusiness: {
      id: 'register-new-business',
      label: 'Register new business entity',
      href: `/instruction/${PRE_LOGIN_INSTRUCTION_ROUTES.ENTITY_REGISTRATION}`,
      icon: SystemIcon.BusinessBusiness,
    },
    applyforNewBusiness: {
      id: 'apply-for-new-business',
      label: 'Apply for new business entity name',
      href: `/instruction/${PRE_LOGIN_INSTRUCTION_ROUTES.NAME_APPLICATION}`,
      icon: SystemIcon.DocumentEdit,
    },
    applyOmit: {
      id: 'apply-omit',
      label: 'Apply to omit the word "Limited" and "Berhad"',
      href: `/instruction/${PRE_LOGIN_INSTRUCTION_ROUTES.GENERAL_LODGEMENT}`,
      icon: SystemIcon.DocumentEdit,
    },
    transferRegistration: {
      id: 'transfer-registration',
      label: 'Transfer of registration for foreign business entity',
      href: `/instruction/${PRE_LOGIN_INSTRUCTION_ROUTES.GENERAL_LODGEMENT}`,
      icon: SystemIcon.GeneralUpdateCheck,
    },
    registerPublic: {
      id: 'register-public',
      label: 'Register public accounting entity status',
      href: `/instruction/${PRE_LOGIN_INSTRUCTION_ROUTES.GENERAL_LODGEMENT}`,
      icon: SystemIcon.BusinessBusiness,
    },
    registerFiling: {
      id: 'register-filing',
      label: 'Register filing access for group of companies',
      href: `/instruction/${PRE_LOGIN_INSTRUCTION_ROUTES.GENERAL_LODGEMENT}`,
      icon: SystemIcon.BusinessCompany,
    },
    registerCorporate: {
      id: 'register-corporate',
      label: 'Register as corporate service provider',
      href: `/instruction/${PRE_LOGIN_INSTRUCTION_ROUTES.REGISTER_CORPORATE_SERVICE_PROVIDER}`,
      icon: SystemIcon.BusinessBusiness,
    },
    registerIndividual: {
      id: 'register-individual',
      label: 'Register as a registered qualified individual',
      href: `/instruction/${PRE_LOGIN_INSTRUCTION_ROUTES.REGISTER_QUALIFIED_INDIVIDUAL}`,
      icon: SystemIcon.ActionPersonAdd,
    },
    registerAccountant: {
      id: 'register-accountant',
      label: 'Register as a public accountant',
      href: `/instruction/${PRE_LOGIN_INSTRUCTION_ROUTES.GENERAL_LODGEMENT}`,
      icon: SystemIcon.ActionPersonAdd,
    },
  },
  MANAGE: {
    updateEntity: {
      id: 'updateEntity',
      label: 'Update entity information',
      href: `/instruction/${PRE_LOGIN_INSTRUCTION_ROUTES.UPDATE_ENTITY_INFO}`,
      icon: SystemIcon.BusinessBusiness,
    },
    updatePersonnel: {
      id: 'updatePersonnel',
      label: 'Update position holder information',
      href: `/instruction/${PRE_LOGIN_INSTRUCTION_ROUTES.UPDATE_PERSONNEL_EDIT_PERSONNEL}`,
      icon: SystemIcon.GeneralPeople,
    },
    appointWithDrawPosition: {
      id: 'appointWithDrawPosition',
      label: 'Appoint/Withdraw position holder',
      href: `/instruction/${PRE_LOGIN_INSTRUCTION_ROUTES.UPDATE_PERSONNEL_APPOINTMENT_WITHDRAWAL}`,
      icon: SystemIcon.GeneralPeople,
    },
    updateShareholder: {
      id: 'updateShareholder',
      label: 'Update shareholder information',
      href: `/instruction/${PRE_LOGIN_INSTRUCTION_ROUTES.UPDATE_SHAREHOLDER}`,
      icon: SystemIcon.BusinessGroupOfCompanies,
    },
    updateListMembers: {
      id: 'updateListMembers',
      label: 'Update list of members (for public company limited by guarantee)',
      href: `/instruction/${PRE_LOGIN_INSTRUCTION_ROUTES.GENERAL_LODGEMENT}`,
      icon: SystemIcon.BusinessGroupOfCompanies,
    },
    updateRegistersNominee: {
      id: 'updateRegistersNominee',
      label: 'Update Registers of Nominee Directors and Nominee Shareholders',
      href: `/instruction/${PRE_LOGIN_INSTRUCTION_ROUTES.UPDATE_DIRECTORS_AND_SHAREHOLDER_NOMINATORS}`,
      icon: SystemIcon.BusinessGroupOfCompanies,
      displayFlag: String(process.env.REACT_APP_MEGAMENU_SHOW_UPDATE_NDNS), // explicit cast to string as pipeline might inject "true/false" string or actual boolean
    },
    updateChangeFinancial: {
      id: 'updateChangeFinancial',
      label: 'Update change of financial year end date',
      href: `/instruction/${PRE_LOGIN_INSTRUCTION_ROUTES.FINANCIAL_YEAR_END}`,
      deprioHref: `/temporary-unavailable`,
      deprioFlag: process.env.REACT_APP_SHOW_FINANCIAL_YEAR_END,
      icon: SystemIcon.GeneralAnnualCalendar,
    },
    fileNoticeResolution: {
      id: 'fileNoticeResolution',
      label: 'File Notice of Resolution',
      href: `/instruction/${PRE_LOGIN_INSTRUCTION_ROUTES.GENERAL_LODGEMENT}`,
      icon: SystemIcon.DocumentRegisters,
    },
    updateRegisterRegistrable: {
      id: 'updateRegisterRegistrable',
      label: 'Update Register of Registrable Controller',
      href: `/instruction/${PRE_LOGIN_INSTRUCTION_ROUTES.MAINTENANCE_OF_RORC}`,
      icon: SystemIcon.GeneralItemsCheck,
    },
    fileNoticeError: {
      id: 'fileNoticeError',
      label: 'File Notice of Error',
      href: `/instruction/${PRE_LOGIN_INSTRUCTION_ROUTES.NOTICE_OF_ERROR}`,
      deprioHref: `/instruction/${PRE_LOGIN_INSTRUCTION_ROUTES.GENERAL_LODGEMENT}`,
      deprioFlag: process.env.REACT_APP_SHOW_NOTICE_OF_ERROR,
      icon: SystemIcon.GeneralNotice,
    },
    fileOrderCourt: {
      id: 'fileOrderCourt',
      label: 'File Order of Court',
      href: `/instruction/${PRE_LOGIN_INSTRUCTION_ROUTES.GENERAL_LODGEMENT}`,
      icon: SystemIcon.GeneralGavel,
    },
    fileAtleration: {
      id: 'fileAtleration',
      label: 'File Alteration of Constitution',
      href: `/instruction/${PRE_LOGIN_INSTRUCTION_ROUTES.GENERAL_LODGEMENT}`,
      icon: SystemIcon.GeneralCourt,
    },
    fileNoticeDeath: {
      id: 'fileNoticeDeath',
      label: 'File notice of death',
      href: `/instruction/${PRE_LOGIN_INSTRUCTION_ROUTES.GENERAL_LODGEMENT}`,
      icon: SystemIcon.GeneralPeople,
    },
    notifyCessation: {
      id: 'notifyCessation',
      label: 'File Notice of Cessation/Resignation of position holder',
      href: `/instruction/${PRE_LOGIN_INSTRUCTION_ROUTES.GENERAL_LODGEMENT}`,
      icon: SystemIcon.GeneralNotice,
    },
    updateShareInformation: {
      id: 'updateShareInformation',
      label: 'Update shares information',
      href: `/instruction/${PRE_LOGIN_INSTRUCTION_ROUTES.COMMON_SHARES}`,
      icon: SystemIcon.BusinessBusiness,
    },
    reduceShareCapital: {
      id: 'reduceShareCapital',
      label: 'Update reduction of share capital',
      href: `/instruction/${PRE_LOGIN_INSTRUCTION_ROUTES.REDUCTION_SHARE_CAPITAL}`,
      icon: SystemIcon.GeneralTrendingDown,
    },
    registerNewCharge: {
      id: 'registerNewCharge',
      label: 'Register new charge',
      href: `/instruction/${PRE_LOGIN_INSTRUCTION_ROUTES.REGISTRATION_OF_CHARGES}`,
      icon: SystemIcon.DocumentQuote,
    },
    fileVariation: {
      id: 'fileVariation',
      label: 'File variation/satisfaction of charges',
      href: `/instruction/${PRE_LOGIN_INSTRUCTION_ROUTES.VARIATION_SATISFACTION}`,
      deprioHref: `/temporary-unavailable`,
      deprioFlag: process.env.REACT_APP_SHOW_VARIATION_SATISFACTION,
      icon: SystemIcon.DocumentQuote,
    },
    convertToLLP: {
      id: 'convertToLLP',
      label: 'Convert to LLP/ALLP',
      href: `/instruction/${PRE_LOGIN_INSTRUCTION_ROUTES.GENERAL_LODGEMENT}`,
      icon: SystemIcon.ActionConvert,
    },
    convertCompanyTypes: {
      id: 'convertCompanyTypes',
      label: 'Convert company types',
      href: `/instruction/${PRE_LOGIN_INSTRUCTION_ROUTES.GENERAL_LODGEMENT}`,
      icon: SystemIcon.ActionConvert,
    },
    registerAmalgamation: {
      id: 'registerAmalgamation',
      label: 'Register amalgamation of companies',
      href: `/instruction/${PRE_LOGIN_INSTRUCTION_ROUTES.GENERAL_LODGEMENT}`,
      icon: SystemIcon.BusinessBusiness,
    },
    maintenanceSubsidiaries: {
      id: 'maintenanceSubsidiaries',
      label: 'Maintain list of subsidiaries',
      href: `/instruction/${PRE_LOGIN_INSTRUCTION_ROUTES.GENERAL_LODGEMENT}`,
      icon: SystemIcon.BusinessCompany,
    },
    maintenanceGroupSecretary: {
      id: 'maintenanceGroupSecretary',
      label: 'Maintain group secretary information',
      href: `/instruction/${PRE_LOGIN_INSTRUCTION_ROUTES.GENERAL_LODGEMENT}`,
      icon: SystemIcon.BusinessGroupOfCompanies,
    },
    maintenanceFilingAccess: {
      id: 'maintenanceFilingAccess',
      label: 'Manage filing access for group of companies employees',
      href: `/instruction/${PRE_LOGIN_INSTRUCTION_ROUTES.GENERAL_LODGEMENT}`,
      icon: SystemIcon.BusinessGroupOfCompanies,
    },
    renewBusiness: {
      id: 'renewBusiness',
      label: 'Renew business registration',
      href: `/instruction/${PRE_LOGIN_INSTRUCTION_ROUTES.ENTITY_RENEWAL}`,
      icon: SystemIcon.GeneralUpdateCheck,
    },
    renewLimitedPartnership: {
      id: 'renewLimitedPartnership',
      label: 'Renew limited partnership registration',
      href: `/instruction/${PRE_LOGIN_INSTRUCTION_ROUTES.ENTITY_RENEWAL}`,
      icon: SystemIcon.GeneralUpdateCheck,
    },
    updateCSPInformation: {
      id: 'updateCSPInformation',
      label: 'Update corporate service provider information',
      href: `/instruction/${PRE_LOGIN_INSTRUCTION_ROUTES.GENERAL_LODGEMENT}`,
      icon: SystemIcon.BusinessBusiness,
    },
    updateRegisteredQualified: {
      id: 'updateRegisteredQualified',
      label: 'Update registered qualified individual information',
      href: `/instruction/${PRE_LOGIN_INSTRUCTION_ROUTES.GENERAL_LODGEMENT}`,
      icon: SystemIcon.GeneralPeople,
    },
    maintenanceCSP: {
      id: 'maintenanceCSP',
      label: 'Maintain corporate service provider client list',
      href: `/instruction/${PRE_LOGIN_INSTRUCTION_ROUTES.MAINTENANCE_OF_CSP_CLIENT_LIST}`,
      icon: SystemIcon.BusinessBusiness,
    },
    maintenanceFilingAccessCSP: {
      id: 'maintenanceFilingAccessCSP',
      label: 'Manage filing access for corporate service provider employees',
      href: `/instruction/${PRE_LOGIN_INSTRUCTION_ROUTES.GENERAL_LODGEMENT}`,
      icon: SystemIcon.BusinessGroupOfCompanies,
    },
    renewRegistrationCSP: {
      id: 'renewRegistrationCSP',
      label: 'Renew registration as corporate service provider',
      href: `/instruction/${PRE_LOGIN_INSTRUCTION_ROUTES.RENEW_CSP}`,
      icon: SystemIcon.GeneralUpdateCheck,
    },
    renewRegistrationRegisteredQualified: {
      id: 'renewRegistrationRegisteredQualified',
      label: 'Renew registration as registered qualified individual',
      href: `/instruction/${PRE_LOGIN_INSTRUCTION_ROUTES.RENEW_QUALIFIED_INDIVIDUAL}`,
      icon: SystemIcon.GeneralUpdateCheck,
    },
    updatePublicAccountant: {
      id: 'updatePublicAccountant',
      label: 'Update public accountant information',
      href: `/instruction/${PRE_LOGIN_INSTRUCTION_ROUTES.GENERAL_LODGEMENT}`,
      icon: SystemIcon.BusinessLimitedPartnership,
    },
    updateApprovedLiquidators: {
      id: 'updateApprovedLiquidators',
      label: 'Update information of approved liquidators',
      href: `/instruction/${PRE_LOGIN_INSTRUCTION_ROUTES.GENERAL_LODGEMENT}`,
      icon: SystemIcon.BusinessLimitedPartnership,
    },
  },
  ANNUAL_FILING: {
    fileAnnualReturns: {
      id: 'fileAnnualReturns',
      label: 'File annual returns',
      href: `/instruction/${PRE_LOGIN_INSTRUCTION_ROUTES.ANNUAL_RETURNS_DECLARATIONS}`,
      icon: SystemIcon.GeneralAnnualCalendar,
    },
    fileFinancialStatements: {
      id: 'fileFinancialStatements',
      label: 'File financial statements',
      href: `/instruction/${PRE_LOGIN_INSTRUCTION_ROUTES.ANNUAL_RETURNS_DECLARATIONS}`,
      icon: SystemIcon.GeneralAnnualCalendar,
    },
    fileAnnualDeclarations: {
      id: 'fileAnnualDeclarations',
      label: 'File annual declarations',
      href: `/instruction/${PRE_LOGIN_INSTRUCTION_ROUTES.ANNUAL_RETURNS_DECLARATIONS}`,
      icon: SystemIcon.GeneralAnnualCalendar,
    },
    applyExemption: {
      id: 'applyExemption',
      label: 'Apply for exemption from financial statement requirements',
      href: `/instruction/${PRE_LOGIN_INSTRUCTION_ROUTES.GENERAL_LODGEMENT}`,
      icon: SystemIcon.GeneralItemsCheck,
    },
    applyExtensionTime: {
      id: 'applyExtensionTime',
      label: 'Apply for extension of time',
      href: `/instruction/${PRE_LOGIN_INSTRUCTION_ROUTES.EXTENSION_OF_TIME}`,
      icon: SystemIcon.GeneralTimer,
    },
    applyExtensionTimeAGM: {
      id: 'applyExtensionTimeAGM',
      label:
        'Apply for extension of time for annual general meeting/annual returns',
      href: `/instruction/${PRE_LOGIN_INSTRUCTION_ROUTES.EXTENSION_OF_TIME}`,
      icon: SystemIcon.GeneralTimer,
    },
    applyExtensionTimeFS: {
      id: 'applyExtensionTimeFS',
      label: 'Apply for extension of time for financial statements',
      href: `/instruction/${PRE_LOGIN_INSTRUCTION_ROUTES.EXTENSION_OF_TIME}`,
      icon: SystemIcon.GeneralTimer,
    },
    applyExtensionTimeDeclarations: {
      id: 'applyExtensionTimeDeclarations',
      label: 'Apply for extension of time for annual declarations',
      href: `/instruction/${PRE_LOGIN_INSTRUCTION_ROUTES.EXTENSION_OF_TIME}`,
      icon: SystemIcon.GeneralTimer,
    },
    fileNotificationAGM: {
      id: 'fileNotificationAGM',
      label: 'File notification of annual general meeting',
      href: `/instruction/${PRE_LOGIN_INSTRUCTION_ROUTES.GENERAL_LODGEMENT}`,
      icon: SystemIcon.GeneralEvent,
    },
    fileVariationSatisfaction: {
      id: 'fileVariationSatisfaction',
      label: 'File variation/satisfaction of charges',
      href: `/instruction/${PRE_LOGIN_INSTRUCTION_ROUTES.VARIATION_SATISFACTION}`,
      deprioHref: '/temporary-unavailable',
      deprioFlag: process.env.REACT_APP_SHOW_VARIATION_SATISFACTION,
      icon: SystemIcon.DocumentQuote,
    },
    bizfinx: {
      id: 'bizfinx',
      label: 'BizFinx',
      href: 'https://www.acra.gov.sg/how-to-guides/filing-financial-statements-in-xbrl-format/workflow-for-preparing-and-filing-xbrl-financial-statements',
      newTab: true,
      icon: SystemIcon.DocumentFillingBox,
    },
  },
  DEREGISTER: {
    applyToRevokePublicAccounting: {
      id: 'applyToRevokePublicAccounting',
      label: 'Apply to revoke public accounting entity status',
      href: `/instruction/${PRE_LOGIN_INSTRUCTION_ROUTES.GENERAL_LODGEMENT}`,
      icon: SystemIcon.BusinessCompanyCancel,
    },
    applyStrikingOff: {
      id: 'applyStrikingOff',
      label: 'Apply to strike off business entity',
      href: `/instruction/${PRE_LOGIN_INSTRUCTION_ROUTES.STRIKE_OFF}`,
      icon: SystemIcon.BusinessSuitcaseCancel,
    },
    manageStrikingOff: {
      id: 'manageStrikingOff',
      label: 'Manage striking off',
      href: `/instruction/${PRE_LOGIN_INSTRUCTION_ROUTES.POST_STRIKE_OFF}`,
      icon: SystemIcon.DocumentEdit,
    },
    submitClearObjections: {
      id: 'submitClearObjections',
      label: 'Submit/Clear objections against striking off',
      href: `/instruction/${PRE_LOGIN_INSTRUCTION_ROUTES.OBJ_STRIKING_OFF}`,
      icon: SystemIcon.DocumentAddDoc,
    },
    applyRestoreBusinessEntity: {
      id: 'applyRestoreBusinessEntity',
      label: 'Apply to restore business entity',
      href: `/instruction/${PRE_LOGIN_INSTRUCTION_ROUTES.GENERAL_LODGEMENT}`,
      icon: SystemIcon.ActionRefresh,
    },
    applyWindingUp: {
      id: 'applyWindingUp',
      label: 'File winding up of business entity',
      href: `/instruction/${PRE_LOGIN_INSTRUCTION_ROUTES.INITIATION_OF_WINDING_UP}`,
      icon: SystemIcon.BusinessSuitcaseCancel,
    },
    manageWindingUp: {
      id: 'manageWindingUp',
      label: 'Manage winding up',
      href: `/instruction/${PRE_LOGIN_INSTRUCTION_ROUTES.POST_INITIATION_OF_WINDING_UP}`,
      deprioHref: `/instruction/${PRE_LOGIN_INSTRUCTION_ROUTES.GENERAL_LODGEMENT}`,
      deprioFlag: process.env.REACT_APP_SHOW_MANAGE_WINDING_UP,
      icon: SystemIcon.DocumentEdit,
    },
    fileSimplifiedWindinUp: {
      id: 'fileSimplifiedWindinUp',
      label: 'File simplified winding up',
      href: `/instruction/${PRE_LOGIN_INSTRUCTION_ROUTES.GENERAL_LODGEMENT}`,
      icon: SystemIcon.GeneralEvent,
    },
    notifySimplifiedRestructuring: {
      id: 'notifySimplifiedRestructuring',
      label: 'File simplified restructuring of debts',
      href: `/instruction/${PRE_LOGIN_INSTRUCTION_ROUTES.GENERAL_LODGEMENT}`,
      icon: SystemIcon.GeneralEvent,
    },
    fileAppointmentCessation: {
      id: 'fileAppointmentCessation',
      label: 'File appointment/cessation of receivers',
      href: `/instruction/${PRE_LOGIN_INSTRUCTION_ROUTES.GENERAL_LODGEMENT}`,
      icon: SystemIcon.BusinessLimitedPartnership,
    },
    fileReceiversAccount: {
      id: 'fileReceiversAccount',
      label: "File receiver's account of receipts and payments",
      href: `/instruction/${PRE_LOGIN_INSTRUCTION_ROUTES.GENERAL_LODGEMENT}`,
      icon: SystemIcon.DocumentQuote,
    },
    fileReceiverStatementAffairs: {
      id: 'fileReceiverStatementAffairs',
      label: 'File receiver’s statement of affairs',
      href: `/instruction/${PRE_LOGIN_INSTRUCTION_ROUTES.GENERAL_LODGEMENT}`,
      icon: SystemIcon.DocumentRegisters,
    },
    fileObjectionEarlyDissolution: {
      id: 'fileObjectionEarlyDissolution',
      label: 'File objection to early dissolution',
      href: `/instruction/${PRE_LOGIN_INSTRUCTION_ROUTES.GENERAL_LODGEMENT}`,
      icon: SystemIcon.DocumentAddDoc,
    },
    applyJudicialManagement: {
      id: 'applyJudicialManagement',
      label: 'File judicial management of company',
      href: `/instruction/${PRE_LOGIN_INSTRUCTION_ROUTES.GENERAL_LODGEMENT}`,
      icon: SystemIcon.GeneralCourt,
    },
    manageJudicialManagement: {
      id: 'manageJudicialManagement',
      label: 'Manage judicial management',
      href: `/instruction/${PRE_LOGIN_INSTRUCTION_ROUTES.GENERAL_LODGEMENT}`,
      icon: SystemIcon.GeneralCourt,
    },
    deregisterFilingAccess: {
      id: 'deregisterFilingAccess',
      label: 'Deregister filing access for group of companies',
      href: `/instruction/${PRE_LOGIN_INSTRUCTION_ROUTES.GENERAL_LODGEMENT}`,
      icon: SystemIcon.BusinessCompanyCancel,
    },
    ceaseDissolveBusinessEntity: {
      id: 'ceaseDissolveBusinessEntity',
      label: 'File cessation or dissolution of business entity',
      href: `/instruction/${PRE_LOGIN_INSTRUCTION_ROUTES.CESSATION_DISSOLUTION}`,
      icon: SystemIcon.BusinessCompanyCancel,
    },
    fileCessation: {
      id: 'fileCessation',
      label: 'File cessation of business entity',
      href: `/instruction/${PRE_LOGIN_INSTRUCTION_ROUTES.CESSATION_DISSOLUTION}`,
      icon: SystemIcon.BusinessCompanyCancel,
    },
    deregisterRegistrationCSP: {
      id: 'deregisterRegistrationCSP',
      label: 'Deregister registration as corporate service provider',
      href: `/instruction/${PRE_LOGIN_INSTRUCTION_ROUTES.GENERAL_LODGEMENT}`,
      icon: SystemIcon.BusinessSuitcaseCancel,
    },
    deregisterRegistrationRegisteredQualified: {
      id: 'deregisterRegistrationRegisteredQualified',
      label: 'Deregister registration as registered qualified individual',
      href: `/instruction/${PRE_LOGIN_INSTRUCTION_ROUTES.GENERAL_LODGEMENT}`,
      icon: SystemIcon.GeneralPeople,
    },
    deregisterRegistrationPublicAccountant: {
      id: 'deregisterRegistrationPublicAccountant',
      label: 'Cancel registration as a public accountant',
      href: `/instruction/${PRE_LOGIN_INSTRUCTION_ROUTES.GENERAL_LODGEMENT}`,
      icon: SystemIcon.GeneralPeople,
    },
    withdrawApprovedLiquidator: {
      id: 'withdrawApprovedLiquidator',
      label: 'Withdraw from being an approved liquidator',
      href: `/instruction/${PRE_LOGIN_INSTRUCTION_ROUTES.GENERAL_LODGEMENT}`,
      icon: SystemIcon.GeneralPeople,
    },
  },
  OTHERS: {
    generalLodgement: {
      id: 'generalLodgement',
      label: 'General lodgement',
      href: `/instruction/${PRE_LOGIN_INSTRUCTION_ROUTES.GENERAL_LODGEMENT}`,
      icon: SystemIcon.DocumentEdit,
    },
    refund: {
      id: 'refund',
      label: 'Request for refund',
      href: `/${MFE.IPS_REFUND}/create/instruction`,
      icon: SystemIcon.PaymentRefund,
    },
    valueAddedServices: {
      id: 'valueAddedServices',
      label: 'Value-added services',
      href: `/${MFE.REGISTRY}/value-added-services`,
      icon: SystemIcon.GeneralRocket,
    },
    applyRestoreBusinessEntity: {
      id: 'applyRestoreBusinessEntity',
      label: 'Apply to restore business entity',
      href: `/instruction/${PRE_LOGIN_INSTRUCTION_ROUTES.GENERAL_LODGEMENT}`,
      icon: SystemIcon.ActionRefresh,
    },
    applyConsentResign: {
      id: 'applyConsentResign',
      label:
        'Apply for consent to resign as auditor of public interest companies or their subsidiaries',
      href: `/instruction/${PRE_LOGIN_INSTRUCTION_ROUTES.GENERAL_LODGEMENT}`,
      icon: SystemIcon.GeneralPeople,
    },
    fileNameComplaint: {
      id: 'fileNameComplaint',
      label: 'File name complaint',
      href: `/instruction/${PRE_LOGIN_INSTRUCTION_ROUTES.GENERAL_LODGEMENT}`,
      icon: SystemIcon.DocumentEdit,
    },
  },
  BUY_INFORMATION: {
    businessProfile: {
      id: 'businessProfile',
      label: 'Business Profile',
      href: `/${MFE.IPS_BUY_INFO}/info-products/business-profile`,
      icon: SystemIcon.BusinessBusiness,
    },
    corporateCompliance: {
      id: 'corporateCompliance',
      label: 'Corporate Compliance and Financial Profile',
      href: `/${MFE.IPS_BUY_INFO}/info-products/ccfp`,
      icon: SystemIcon.DocumentQuote,
    },
    peopleProfile: {
      id: 'peopleProfile',
      label: 'People Profile',
      href: `/${MFE.IPS_BUY_INFO}/info-products/people-profile`,
      icon: SystemIcon.DocumentPeopleProfile,
    },
    extracts: {
      id: 'extracts',
      label: 'Extracts',
      href: `/${MFE.IPS_BUY_INFO}/info-products/extracts`,
      icon: SystemIcon.DocumentExtracts,
    },
    certificates: {
      id: 'certificates',
      label: 'Certificates',
      href: `/${MFE.IPS_BUY_INFO}/info-products/certificates`,
      icon: SystemIcon.DocumentCertificate,
    },
    registers: {
      id: 'registers',
      label: 'Registers',
      href: `/${MFE.IPS_BUY_INFO}/info-products/registers`,
      icon: SystemIcon.DocumentRegisters,
    },
    productDownload: {
      id: 'productDownload',
      label: 'Product Download',
      href: ISHOP_LINKS.PRODUCT_DOWNLOAD,
      icon: SystemIcon.DocumentDocument,
    },
    trustBarAuthentication: {
      id: 'trustBarAuthentication',
      label: 'trustBar authentication',
      href: 'https://www.acratrustbar.gov.sg/',
      icon: SystemIcon.GeneralItemsCheck,
      newTab: true,
    },
    pdfProductAuthentication: {
      id: 'pdfProductAuthentication',
      label: 'PDF product authentication',
      href: `/${MFE.IPS_BUY_INFO}/authenticate/pdf-product`,
      icon: SystemIcon.DocumentPdf,
    },
    variableCapitalCompanies: {
      id: 'variableCapitalCompanies',
      label: 'Variable Capital Companies',
      href: ISHOP_LINKS.VCC_PORTAL,
      icon: SystemIcon.BusinessCompany,
      newTab: true,
    },
    requestForPermissionDisc: {
      id: 'requestForPermissionDisc',
      label: 'Request for Permissible Disclosure Information',
      href: process.env.REACT_APP_REQUEST_PERMISSION_DISCLOSURE_URL ?? '#',
      icon: SystemIcon.DocumentEdit,
      newTab: true,
    },
  },
  SUBSCRIBE_APIS: {
    gettingStarted: {
      id: 'gettingStarted',
      label: 'Getting started',
      href: `/${MFE.IPS_API_MARKETPLACE}/getting-started`,
      icon: SystemIcon.GeneralRocket,
    },
    dataApiCategories: {
      id: 'dataApiCategories',
      label: 'Data API categories',
      href: `/${MFE.IPS_API_MARKETPLACE}/categories/data-api/eiq`,
      icon: SystemIcon.TechDatasets,
    },
    transactionalApiCategories: {
      id: 'transactionalApiCategories',
      label: 'Transactional API categories',
      href: `/${MFE.IPS_API_MARKETPLACE}/categories/transactional-api`,
    },
    apimManagement: {
      id: 'apimManagement',
      label: 'API marketplace management',
      href: `/${MFE.IPS_API_MARKETPLACE}/management`,
      icon: SystemIcon.GeneralSettings,
    },
    entityInfoQuery: {
      id: 'entityInfoQuery',
      label: 'Entity Information Query',
      href: `/${MFE.IPS_API_MARKETPLACE}/categories/data-api/eiq`,
      icon: SystemIcon.TechDatasets,
    },
    financialInfoQuery: {
      id: 'financialInfoQuery',
      label: 'Financial Information Query',
      href: `/${MFE.IPS_API_MARKETPLACE}/categories/data-api/fiq`,
      icon: SystemIcon.TechDatasets,
    },
    trustbarInfoQuery: {
      id: 'trustbarInfoQuery',
      label: 'trustBar Information Query',
      href: `/${MFE.IPS_API_MARKETPLACE}/categories/data-api/tvq`,
      icon: SystemIcon.TechDatasets,
    },
  },
  DOWNLOAD_AUTH: {
    downloadBiz: {
      id: 'downloadBiz',
      label: 'Download business information product',
      href: ISHOP_LINKS.PRODUCT_DOWNLOAD,
      icon: SystemIcon.DocumentDocument,
    },
    trustBarAuthentication: {
      id: 'trustBarAuthentication',
      label: 'trustBar authentication',
      href: 'https://www.acratrustbar.gov.sg/',
      icon: SystemIcon.GeneralItemsCheck,
      newTab: true,
    },
    pdfProductAuthentication: {
      id: 'pdfProductAuthentication',
      label: 'PDF product authentication',
      href: `/${MFE.IPS_BUY_INFO}/authenticate/pdf-product`,
      icon: SystemIcon.DocumentPdf,
    },
  },
};
